var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSafety = function SvgSafety(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.675 20.85q-.65 0-1.087-.45-.438-.45-.438-1.1v-8.675q0-.625.438-1.075.437-.45 1.087-.45H8.1V7.125q0-1.625 1.138-2.763Q10.375 3.225 12 3.225t2.762 1.137Q15.9 5.5 15.9 7.125V9.1h1.425q.65 0 1.088.45.437.45.437 1.075V19.3q0 .65-.437 1.1-.438.45-1.088.45Zm0-.925h10.65q.275 0 .45-.175t.175-.45v-8.675q0-.275-.175-.437-.175-.163-.45-.163H6.675q-.275 0-.45.163-.175.162-.175.437V19.3q0 .275.175.45t.45.175Zm5.325-3.5q.6 0 1.025-.425.425-.425.425-1.025 0-.625-.412-1.037-.413-.413-1.038-.413-.6 0-1.025.413-.425.412-.425 1.037 0 .6.413 1.025.412.425 1.037.425ZM9.025 9.1h5.95V7.125q0-1.225-.862-2.1Q13.25 4.15 12 4.15q-1.225 0-2.1.875t-.875 2.1ZM6.05 19.925v-9.9 9.9Z"
  })));
};

export { SvgSafety as ReactComponent };
export default __webpack_public_path__ + "safety.svg";